// this file is generated by update_shopify_store_data.py at 2026-02-23 20:31:08.134909
var courses = [];